export default __webpack_public_path__ + "static/media/group4.64e96502.png";